import { render } from "./pop-up.vue?vue&type=template&id=5470f73b&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=5470f73b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5470f73b"

export default script